"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const botones_1 = require("../botones");
const text_1 = require("../grid2Base/simpleGrid/text");
class JsonNodeComponent extends React.PureComponent {
    render() {
        const x = this.props.value;
        const key = this.props.propname;
        return (React.createElement("span", null,
            (key != null && key != "" && this.props.onClick) &&
                React.createElement("span", { style: { fontWeight: "bold", color: "#231858" } }, React.createElement(botones_1.Link, { style: "info", onClick: this.props.onClick, iconClass: "fa fa-eye" })),
            text_1.cellToText(x.value)));
    }
}
exports.JsonNodeComponent = JsonNodeComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/jsonview/node.js
// module id = 2238
// module chunks = 0